import * as React from 'react';
import '../ux_styles.css';
import MediaQuery from 'react-responsive';
import { DEVICE_WIDTH_DESKTOP } from './ResponsivePage';

interface Props {
    
}

export default class extends React.Component<Props, {}> {

	constructor(props: Props) {
		super(props);
	}

	render() {
		return (
			<MediaQuery minWidth={DEVICE_WIDTH_DESKTOP}>
				{this.props.children}
			</MediaQuery>
		)
	}
}
